import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

const DisplayBlog = () => {
  const [blog, setBlog] = useState();

  const { blogId } = useParams();

  useEffect(() => {
    fetch(`https://youtube-api-blog-site-server.vercel.app/blogs/${blogId}`)
      .then((res) => res.json())
      .then((data) => setBlog(data));
  }, [blogId]);

  return (
    <div>
      <div className="container card md:w-2/3 mx-auto text-black shadow-xl m-10">
        <div className="card-body">
          <div className="card-actions justify-end">
            <Link to={"/blogs"} className="btn btn-square btn-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </Link>
          </div>
          <div className="flex flex-col justify-center items-center">
            <img
              className="w-[450px] h-[265px] rounded-lg"
              src={blog?.img}
              alt=""
            />
            <h1 className="text-3xl font-bold mb-3 mt-5">{blog?.title}</h1>
            <p className="text-xl">{blog?.blogText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayBlog;
